import script from "./CompanyDetailsSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDetailsSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDetailsSkeleton.vue?vue&type=style&index=0&id=6906cf80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6906cf80"]])

export default __exports__